var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"layout-primary"},[_vm._t("default",function(){return [_c('transition',{attrs:{"name":"none"}},[_c('router-view')],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }